import React from "react";
import Slider from "../components/Swiper/AboutUsSwiper/Slider.jsx";
import about1 from "../components/photos/aboutUs/about1.jsx";
import about2 from "../components/photos/aboutUs/about2.jsx";
import about3 from "../components/photos/aboutUs/about3.jsx";
import about4 from "../components/photos/aboutUs/about4.jsx";
import about5 from "../components/photos/aboutUs/about5.jsx";
import about6 from "../components/photos/aboutUs/about6.jsx";

const array = [about1, about2, about3, about4, about5, about6];

const AboutUs2 = () => {
  return (
    <div className="content">
      <Slider render={array} start={1} />
    </div>
  );
};

export default AboutUs2;
